import { useModules } from './modules';
import { usePlatform } from './platform';

const useNavigation = () => {
  const platformConfig = usePlatform();
  const { sidebarNavigation, mobileNavigation } = useModules();

  return platformConfig?.hideSidebarNavigation ? mobileNavigation : sidebarNavigation;
};

export default useNavigation;
